/**
 * Build stamp injected by Vite at compile time (see vite.config.js `define`).
 *
 * These are literals replaced during the build, not runtime lookups — the values
 * are frozen into whichever bundle is being served, which is what makes the
 * footer's version trustworthy.
 */

export const APP_VERSION = __APP_VERSION__;
export const GIT_SHA = __GIT_SHA__;
export const BUILT_AT = __BUILT_AT__;

/** "v1.4.2 · a1b2c3d" — what the sidebar footer shows. */
export const BUILD_STAMP = `v${APP_VERSION} · ${GIT_SHA}`;
